import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
import _ from "lodash";
import { BrowserRouter, Route } from "react-router-dom";
import StaffSearch from "../components/CompanyCommonSearch";
import MMTopPane from "../components/MMTopPane";
import MDSubBanner from "../components/MDSubBanner";
import ErrorMessage from "../components/ErrorMessage";
import MMPLDashboard from "../components/MMPLDashboard";
import userRoles from "../helpers/role";
import PageLoader from "../Shared/PageLoader";
import { hideLoader, showLoader } from "../Actions/PageLoaderAPI";
import ShippingCompanySearch from "./ShippingCompanySearch";
import DeviceCalibrationSearch from "./DeviceCalibrationSearch";
import ComapnyShipDetails from "./ComapnyShipDetails";
import CompanyCommonSearch from "./CompanyCommonSearch";
import ShipManagement from "./ShipManagement";
import ShipManagementDetail from "./ShipManagementDetail";
import ShipManagementEditItem from "./ShipManagementEdititem";
import StaffManagement from "./StaffManagement";
import StaffManagementDetail from "./StaffManagementDetail";
import StaffManagementEdit from "./StaffManagementEdit";
import StaffManagementAdd from "./StaffManagementAdd";
import UserManagement from "./UserManagement";
import SpecialAccessUserManagement from "./SpecialAccessUserManagement";
import EditUser from "./EditUser";
import EditSpecialAccessUser from "./EditSpecialAccessUser";
import ShipDashboard from "./ComapnyShipDetails";
import AddDevice from "./AddDevice";
import AddCrewMember from "./AddCrewMember";
import CrewSearch from "./CrewSearch";
import CrewVisitorSearch from "./CrewVisitorSearch";
import DeviceManagement from "./DeviceManagement";
import DeviceManagementDetail from "./DeviceManagementDetail";
import DeviceManagementEdit from "./DeviceManagementEdit";
import ShipManagementAdd from "./ShipManagementAdd";
import AddUser from "./AddUser";
import AddSpecialAccessUser from "./AddSpecialAccessUser";
import ReportSearch from "./ReportSearch";
import CrewManagement from "./CrewManagement";
import CrewEdit from "./CrewEdit";
import ShippingCompanyDashboard from "./ShippingCompanyDashboard";
import ShippingSettings from "./ShippingSettings";
import ShippingSettingsDetail from "./ShippingSettingsDetail";
import AddShippingSettings from "./AddShippingSettings";
import EditSettings from "./EditShippingSettings";
import CrewManagementDetail from "./CrewManagementDetail";
import ClientManagementAdd from "./ClientManagementAdd";
import ClientManagement from "./ClientManagement";
import ClientManagementDetail from "./ClientManagementDetail";
import ClientManagementEdit from "./ClientManagementEdit";
import newFleetManager from "./newFleetManager";
import newTechSuperintendent from "./newTechSuperintendent";
import newTechExecutive from "./newTechExecutive";
import EditFleetManager from "./EditFleetManager";
import EditSuperintendent from "./EditSuperintendent";
import EditExecutive from "./EditExecutive";
import ChangePassword from "./ChangePassword";
import RankManagement from "./RankManagement";
import AddRank from "./AddRank";
import EditRank from "./EditRank";
import VisitorManagementDetail from "./VisitorManagementDetail";
import VisitorManagement from "./VisitorManagement";
import AddVisitorMember from "./AddVisitorMember";
import VisitorEdit from "./VisitorEdit";
import CompanyCrewSearch from "./CompanyCrewSearch";
import MonthlyReports from "./MonthlyReports";
import MonthlyReportComments from "./MonthlyReportComments";
import MonthlyReportCommentEdit from "./MonthlyReportCommentEdit";

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rolename: "",
    };
  }

  componentWillMount() {
    const { dispatch } = this.props;
    axios.interceptors.request.use(
      (config) => {
        dispatch(showLoader());
        const userDetails = localStorage.getItem("currentUser");
        let userToken = JSON.parse(userDetails);
        if (userToken) {
          config.headers["Authorization"] = "Bearer " + userToken.accessToken;
        }
        return config;
      },
      function (error) {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (response) {
        dispatch(hideLoader());
        return response;
      },
      function (error) {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  }

  render() {
    const {
      showSidePane,
      IsSMDEdit,
      MMPLSidePanCollectDocs,
      ShowStaffPendingTaskPanel,
      editPOView,
      showPODetail,
    } = this.props;
    let Role = localStorage.getItem("UserRoles");
    return (
      <>
        <BrowserRouter>
          <Route path="/Home" component={MMTopPane}></Route>
          <Route
            path="/Home"
            render={() => {
              return window.location.href.indexOf("/Home/Ship") !==
                -1 ? null : (
                <Route path="/Home" component={MDSubBanner}></Route>
              );
            }}
          />
          <Route
            path="/Home/StaffDashboard/:type?/:email?/:id?"
            render={() => {
              let hj = window.location.href.indexOf(
                "/Home/StaffDashboard/:type?/:email?/id?"
              );

              return window.location.href.indexOf(
                "/Home/StaffDashboard/:type?/:email?/id?"
              ) !== -1 && Role !== userRoles.staff ? (
                <Route path="/Home" component={MDSubBanner}></Route>
              ) : null;
            }}
          />
          {Role == userRoles.mmpl || Role == userRoles.mmpladmin ? (
            <div className="row px-4">
              <div className="col-lg-12">
                <Route
                  path="/Home/Search/:id?"
                  component={CrewVisitorSearch}
                ></Route>
              </div>
            </div>) : null}

          {Role == userRoles.staff ? (
            <div className="row px-4">
              <div className="col-lg-12">
                <Route
                  path="/Home/Search/:id?"
                  component={StaffSearch}
                ></Route>
              </div>
            </div>
          ) : null}
          {Role == userRoles.client || Role == userRoles.clientuser || Role == userRoles.consultant ? (
            <div className="row px-4">
              <div className="col-lg-12">
                <Route
                  path="/Home/Search/:id?"
                  component={CrewVisitorSearch}
                ></Route>
              </div>
            </div>
          ) : null}

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Client/ShipDetails/:id"
                component={ShippingCompanySearch}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Client/CrewVisitorDetails/:id"
                component={CompanyCommonSearch}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Client/Ship/ShipDetails/:id"
                component={ComapnyShipDetails}
              ></Route>
            </div>
          </div>
          {Role == userRoles.mmpl || Role == userRoles.mmpladmin ? (
            <>
              <div className="row px-4">
                <div className="col-sm-12 col-md-12 col-lg-12 col-lg-12">
                  <Route
                    path="/Home/MMPLDashboard"
                    component={MMPLDashboard}
                  ></Route>
                </div>
              </div>
            </>
          ) : null}

          {Role == userRoles.staff ? (
            <div className="row px-4">
              <div className="col-sm-12 col-md-12 col-lg-12 col-lg-12">
                <Route
                  path="/Home/StaffDashboard/:type?/:email?/:id?"
                  component={ComapnyShipDetails}
                ></Route>
              </div>
            </div>
          ) : null}

          {Role == userRoles.client || Role == userRoles.clientuser || Role == userRoles.consultant ? (
            <div className="row px-4">
              <div className="col-sm-12 col-md-12 col-lg-12 col-lg-12">
                <Route
                  path="/Home/CompanyDashboard"
                  component={ShippingCompanySearch}
                ></Route>
              </div>{" "}
            </div>
          ) : null}
          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/Ship"
                component={ShipManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/Ship/:id"
                  component={ShipManagementDetail}
                ></Route>
              </div>
            ) : null}
          </div>
          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"} `}>
              <Route
                path="/Home/Management/ShipEdit/:id"
                component={ShipManagementEditItem}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/ShipAdd"
                component={ShipManagementAdd}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/Report/:id?"
                component={ReportSearch}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/MonthlyReport"
                component={MonthlyReports}
              ></Route>
            </div>
          </div>
          {Role == userRoles.staff ? (
            <>
              <div className="row px-4">
                <div className="col-lg-12">
                  <Route
                    exact
                    path="/Home/Management/MonthlyReportComments/:id"
                    component={MonthlyReportCommentEdit}
                  ></Route>
                </div>
              </div>
              <div className="row px-4">
                <div className="col-lg-12">
                  <Route
                    exact
                    path="/Home/Management/MonthlyReportComments"
                    component={MonthlyReportComments}
                  ></Route>
                </div>
              </div>
            </>
          ) : null}

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route path="/Home/Settings" component={ShippingSettings}></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Settings/:id"
                  component={ShippingSettingsDetail}
                ></Route>
              </div>
            ) : null}
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/AddSettings"
                component={AddShippingSettings}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"} `}>
              <Route
                path="/Home/EditSettings/:id"
                component={EditSettings}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/CompanyDetails/:type/:email?/:name?"
                component={ShippingCompanyDashboard}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/Device"
                component={DeviceManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/Device/:id"
                  component={DeviceManagementDetail}
                ></Route>
              </div>
            ) : null}
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/AddDevice"
                component={AddDevice}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/DeviceEdit/:id"
                component={DeviceManagementEdit}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/DeviceCalibration"
                component={DeviceCalibrationSearch}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Client/Ship/DeviceCalibration/:id"
                component={DeviceCalibrationSearch}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/client/DeviceCalibration/:id"
                component={DeviceCalibrationSearch}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Client/CrewDetails/:id"
                component={CompanyCrewSearch}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/Staff"
                component={StaffManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/Staff/:id"
                  component={StaffManagementDetail}
                ></Route>
              </div>
            ) : null}
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/StaffAdd"
                component={StaffManagementAdd}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/ChangePassword"
                component={ChangePassword}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/StaffEdit/:id"
                component={StaffManagementEdit}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/CrewManagement"
                component={CrewManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/CrewManagement/:id"
                  component={CrewManagementDetail}
                ></Route>
              </div>
            ) : null}
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/AddCrewMember"
                component={AddCrewMember}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/EditCrew/:id"
                component={CrewEdit}
              ></Route>
            </div>
          </div>


          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/CrewManagement"
                component={CrewManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/CrewManagement/:id"
                  component={CrewManagementDetail}
                ></Route>
              </div>
            ) : null}
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/AddCrewMember"
                component={AddCrewMember}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/VisitorManagement"
                component={VisitorManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/VisitorManagement/:id"
                  component={VisitorManagementDetail}
                ></Route>
              </div>
            ) : null}
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/CrewSearch/:id?"
                component={CrewSearch}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/AddNewVisitor"
                component={AddVisitorMember}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/EditVisitor/:id"
                component={VisitorEdit}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/User"
                component={UserManagement}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/SpecialAccessUser"
                component={SpecialAccessUserManagement}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/AddUser"
                component={AddUser}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/AddSpecialAccessUser"
                component={AddSpecialAccessUser}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/EditUser/:id"
                component={EditUser}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/EditSpecialAccessUser/:id"
                component={EditSpecialAccessUser}
              />
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/Rank"
                component={RankManagement}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/AddRank"
                component={AddRank}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/EditRank/:id"
                component={EditRank}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/Client"
                component={ClientManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/Client/:id"
                  component={ClientManagementDetail}
                ></Route>
              </div>
            ) : null}
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/ClientAdd"
                component={ClientManagementAdd}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/ClientAdd/FleetManager"
                  component={newFleetManager}
                ></Route>
                <Route
                  path="/Home/Management/ClientAdd/TechSuperintendent"
                  component={newTechSuperintendent}
                ></Route>
                <Route
                  path="/Home/Management/ClientAdd/TechExecutive"
                  component={newTechExecutive}
                ></Route>
              </div>
            ) : null}
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"}`}>
              <Route
                path="/Home/Management/ClientEdit/:id"
                component={ClientManagementEdit}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/Management/ClientEdit/:id/EditFleetManager"
                  component={EditFleetManager}
                ></Route>
                <Route
                  path="/Home/Management/ClientEdit/:id/EditTechSuperintendent"
                  component={EditSuperintendent}
                ></Route>
                <Route
                  path="/Home/Management/ClientEdit/:id/EditTechExecutive"
                  component={EditExecutive}
                ></Route>
              </div>
            ) : null}
          </div>

          <Route path="/Error" component={ErrorMessage}></Route>
          <PageLoader />
        </BrowserRouter>
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  // const {oidcReducer, viewActionReducer, LayoutReducer} = state;
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    SubBannerTitle: state.SubBannerrTitle || "MD Library",
    ShowMISidePan: state.ShowMISidePan || false,
    ShowRDSidePan: state.ShowRDSidePan || false,
    ShowEURegSidePan: state.ShowEURegSidePan || false,
    isAttachment: state.SidePanReducer.isAttachment
      ? state.SidePanReducer.isAttachment
      : false,
    IsSMDEdit: state.SidePanReducer.IsSMDEdit,
    editPOView: state.SidePanReducer.EditPOView || false,
    ShowStaffPendingTaskPanel:
      state.SidePanReducer.ShowStaffPendingTaskPanel || false,
    showPODetail: state.SidePanReducer.ShowPODetail || false,
    editPendingTaskPresence:
      state.SidePanReducer.EditPendingTaskPresence || false,
    editPendingTaskRevision:
      state.SidePanReducer.EditPendingTaskRevision || false,
    // isAuthenticated: state.SidePanReducer.isAuthenticated,
    Role: state.SidePanReducer.UserRole || null,
    MMPLSidePanCollectDocs: state.MMPLDashboardReducer.MMPLSidePanCollectDocs,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));
